import './index_web.css';
import React from 'react';
import useTheme from '../../utilities/hooks/theme';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { isMatchInScheduled } from '../../utilities/helper';
import Constants from '../../constants';
import View from '../view';
import Text from '../text';
import { CounterWrapper } from './index';

interface Props {
  matchItem?: any;
  onPressBack?: React.MouseEventHandler;
  onlyTimer?: boolean;
  tabType?: string;
  onCalledDeadline?: any;
  onlyTitle?: any;
  screen?: string;
  teamName?: string;
  gameType?: string;
}

const HeaderWithTimerWeb = ({
  matchItem,
  onPressBack,
  onlyTimer = false,
  onlyTitle = false,
  onCalledDeadline,
  teamName = '',
  gameType
}: Props) => {
  const { ComponentTheme } = useTheme();
  const {
    teamA = {},
    teamB = {},
    status: matchStatus,
    verified,
    gameState = 0,
    matchDelayed = false
  } = matchItem;

  const matchTitleTextColor = {
    color: ComponentTheme.headerTitle
  };

  const isMatchScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });
  const timerIconDimension = '20px';
  return (
    <View
      className="header-with-timer-container"
      style={{
        backgroundImage: `linear-gradient(to right,${ComponentTheme.headerStartColor},
        ${ComponentTheme.headerEndColor}
        )`
      }}>
      <View onPress={onPressBack} className="header-with-timer-back-btn-wrapper">
        <IoIosArrowRoundBack fill={ComponentTheme.headerBackIcon} size={45} />
      </View>
      {!onlyTimer && (
        <Text style={matchTitleTextColor} className="header-with-timer-title">
          {`${teamA?.shortName} vs  ${teamB?.shortName}`}
        </Text>
      )}
      {teamName && (
        <Text style={matchTitleTextColor} className="header-with-timer-team-title">
          {`${teamName}`}
        </Text>
      )}
      <View className="header-with-timer-wrapper">
        {isMatchScheduled && !onlyTitle && (
          <View className="header-with-timer-icon-wrapper">
            <Constants.Svgs.Timer width={timerIconDimension} height={timerIconDimension} />
          </View>
        )}
        {!onlyTitle && (
          <CounterWrapper
            onCalledDeadline={onCalledDeadline}
            matchStatus={matchStatus}
            verified={verified}
            matchItem={matchItem}
            isMatchScheduled={isMatchScheduled}
            gameType={gameType}
          />
        )}
      </View>
    </View>
  );
};
export default React.memo(HeaderWithTimerWeb);
